import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const ar = {
  nav: { dashboard: 'لوحة التحكم', appointments: 'المواعيد', patients: 'المرضى', followup: 'المتابعة', messages: 'الرسائل', settings: 'الإعدادات' },
  auth: { login: 'تسجيل الدخول', register: 'إنشاء حساب', phone: 'رقم الهاتف', password: 'كلمة المرور', logout: 'تسجيل الخروج' },
  dashboard: { welcome: 'مرحباً بك', today: 'اليوم', appointments: 'المواعيد', patients: 'المرضى', revenue: 'الإيرادات', pendingAlerts: 'تنبيهات معلقة' },
  common: { save: 'حفظ', cancel: 'إلغاء', add: 'إضافة', edit: 'تعديل', delete: 'حذف', loading: 'جارٍ التحميل...', yes: 'نعم', no: 'لا', search: 'بحث...', view: 'عرض', confirm: 'تأكيد' },
};

const en = {
  nav: { dashboard: 'Dashboard', appointments: 'Appointments', patients: 'Patients', followup: 'Follow-up', messages: 'Messages', settings: 'Settings' },
  auth: { login: 'Sign In', register: 'Create Account', phone: 'Phone', password: 'Password', logout: 'Sign Out' },
  dashboard: { welcome: 'Welcome back', today: 'Today', appointments: 'Appointments', patients: 'Patients', revenue: 'Revenue', pendingAlerts: 'Pending Alerts' },
  common: { save: 'Save', cancel: 'Cancel', add: 'Add', edit: 'Edit', delete: 'Delete', loading: 'Loading...', yes: 'Yes', no: 'No', search: 'Search...', view: 'View', confirm: 'Confirm' },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ar: { translation: ar }, en: { translation: en } },
    fallbackLng: 'ar',
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });

export default i18n;
